import { lazy } from "react";
import { officeBuildingSVG } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import( /* webpackChunkName: "agencies" */ './components/EntryPoint'));
const AgenciesLoader = lazy(() => import( /* webpackChunkName: "agenciesLoader" */ './components/AgenciesLoader'));
const AgencyForm = lazy(() => import( /* webpackChunkName: "agencyForm" */ './components/AgencyForm'));

export const defaultPath = '/agencies';

export const innerRoutes = [
    {
        path: `${defaultPath}/`,
        Component: AgenciesLoader,
        exact: true,
        icon: officeBuildingSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'agency_list',
            plural: false
        }
    },
    {
        path: `${defaultPath}/new`,
        Component: AgencyForm,
        exact: true,
        icon: officeBuildingSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'create_new_agency',
            plural: false
        }
    },
    {
        path: `${defaultPath}/:id`,
        Component: AgencyForm,
        exact: true,
        icon: officeBuildingSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'modify_agency',
            plural: false
        }
    }
];

const Contacts = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: officeBuildingSVG,
    title: {
        key: 'agencies',
        plural: false
    },
    subTitle: {
        key: 'agency_list',
        plural: false
    },
    innerRoutes: innerRoutes,
    pathChilds: innerRoutes.map(e => e.path)
};

export default Contacts;
